<template>
    <div class="home" >
         <PageTitle icon="fa fa-home" main="Home"
            sub="Gestão da Empresa" />
        <div class="home-pages-tabs">    
        <b-card title="Card Title" no-body>
        <b-tabs pills card >
            <b-tab active>
            <template v-slot:title>
                <i class="fa fa-clone"></i> <strong>Contract Information</strong>
            </template>
                <SearchRelease />
            </b-tab>

            <b-tab>
            <template v-slot:title>
                <i class="fa fa-search"></i> <strong>Financial Information</strong>
            </template>
            <AllRelease />
            </b-tab>
             <b-tab>
            <template v-slot:title>
                <i class="fa fa-search"></i> <strong>Service Request</strong>
            </template>
            <AllRelease />
            </b-tab>
        </b-tabs>    
                
        </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import SearchRelease from '../releasebase/SearchRelease'
import AllRelease from '../releasebase/AllRelease'

export default {
    name: 'DashTenant',
    components:{PageTitle,SearchRelease,AllRelease},
    data: function(){
        return {
            
        }
    },
    methods:{

    },
    mounted(){
    
    }
}
</script>

<style>
     .home {
            font-size: 0.7rem;
        }
</style>
